import { getBackbone, getServiceCatalog } from '@/library/http';

export const getBlueprints = async (
  limit: number,
  skip: number,
  sortBy: string,
  descending: boolean,
  dateFrom: string,
  dateTo: string,
  id: string,
  uuid: string,
  inputVariablesSchema: string,
  authorizationSchema: string,
  subSchemas: string,
  deleted: boolean,
) => {
  let filter = '';
  filter += `&order=${descending ? 'DESC' : 'ASC'}`;
  if (sortBy?.length) filter += `&orderBy=${sortBy}`;
  if (id?.length) filter += `&id=${encodeURIComponent(id)}`;
  if (uuid?.length) filter += `&uuid=${encodeURIComponent(uuid)}`;
  if (deleted) filter += `&deleted=true`;
  if (dateFrom?.length) filter += `&from=${encodeURIComponent(dateFrom)}`;
  if (dateTo?.length) filter += `&to=${encodeURIComponent(dateTo)}`;
  if (inputVariablesSchema?.length) filter += `&inputVariablesSchema=${encodeURIComponent(inputVariablesSchema)}`;
  if (authorizationSchema?.length) filter += `&authorizationSchema=${encodeURIComponent(authorizationSchema)}`;
  if (subSchemas?.length) filter += `&subSchemas=${encodeURIComponent(subSchemas)}`;

  return getBackbone(`/blueprints/?limit=${limit}&skip=${skip}${filter}`);
};

export const getAuthorizationSchemas = async (
  limit: number,
  skip: number,
  sortBy: string,
  descending: boolean,
  dateFrom: string,
  dateTo: string,
  id: string,
  uuid: string,
  schema: string,
  deleted: boolean,
) => {
  let filter = '';
  filter += `&order=${descending ? 'DESC' : 'ASC'}`;
  if (sortBy?.length) filter += `&orderBy=${sortBy}`;
  if (id?.length) filter += `&id=${encodeURIComponent(id)}`;
  if (uuid?.length) filter += `&uuid=${encodeURIComponent(uuid)}`;
  if (schema?.length) filter += `&schema=${encodeURIComponent(schema)}`;
  if (dateFrom?.length) filter += `&from=${encodeURIComponent(dateFrom)}`;
  if (dateTo?.length) filter += `&to=${encodeURIComponent(dateTo)}`;
  if (deleted) filter += `&deleted=true`;
  return getBackbone(`/auth-schemas/?limit=${limit}&skip=${skip}${filter}`);
};

export const getAuthorizationSchema = async (id: string) => getBackbone(`/auth-schemas/${encodeURIComponent(id)}`);

export const getInfraServiceConfigs = async (
  limit: number,
  skip: number,
  sortBy: string,
  descending: boolean,
  dateFrom: string,
  dateTo: string,
  apmId: string,
  uuid: string,
  status: string,
  manifest: string,
  deleted: boolean,
) => {
  let filter = '';
  filter += `&order=${descending ? 'DESC' : 'ASC'}`;
  if (sortBy?.length) filter += `&orderBy=${sortBy}`;
  if (apmId?.length) filter += `&apmid=${encodeURIComponent(apmId)}`;
  if (uuid?.length) filter += `&uuid=${encodeURIComponent(uuid)}`;
  if (status?.length) filter += `&status=${encodeURIComponent(status)}`;
  if (manifest?.length) filter += `&manifest=${encodeURIComponent(manifest)}`;
  if (dateFrom?.length) filter += `&from=${encodeURIComponent(dateFrom)}`;
  if (deleted) filter += `&deleted=true`;
  if (dateTo?.length) filter += `&to=${encodeURIComponent(dateTo)}`;
  return getBackbone(`/infra-service-configs/?limit=${limit}&skip=${skip}${filter}`);
};

export const getInfraServiceConfig = async (apmid: string) =>
  getBackbone(`/infra-service-configs/${encodeURIComponent(apmid)}`);

export const getServiceSchemas = async (
  limit: number,
  skip: number,
  sortBy: string,
  descending: boolean,
  dateFrom: string,
  dateTo: string,
  deleted: boolean,
  id: string,
  uuid: string,
  schema: string,
) => {
  let filter = '';
  filter += `&order=${descending ? 'DESC' : 'ASC'}`;
  if (sortBy?.length) filter += `&orderBy=${sortBy}`;
  if (id?.length) filter += `&id=${encodeURIComponent(id)}`;
  if (uuid?.length) filter += `&uuid=${encodeURIComponent(uuid)}`;
  if (schema?.length) filter += `&schema=${encodeURIComponent(schema)}`;
  if (dateFrom?.length) filter += `&from=${encodeURIComponent(dateFrom)}`;
  if (deleted) filter += `&deleted=true`;
  if (dateTo?.length) filter += `&to=${encodeURIComponent(dateTo)}`;
  return getBackbone(`/service-schemas/?limit=${limit}&skip=${skip}${filter}`);
};

export const getServiceSchema = async (id: string) => getBackbone(`/service-schemas/${encodeURIComponent(id)}`);

export const getInfraServices = async (
  limit: number,
  skip: number,
  orderBy: string,
  descending: boolean,
  displayName: string,
  apmid: string,
  orderable: boolean,
  isCatalogPart: boolean,
  parentOnly: boolean,
  deleted: boolean,
  kind: string,
) => {
  let filter = '';
  filter += `&order=${descending ? 'DESC' : 'ASC'}`;
  if (orderBy?.length) filter += `&orderBy=${orderBy}`;
  if (displayName?.length) filter += `&display_name=${encodeURIComponent(displayName)}`;
  if (apmid?.length) filter += `&apmid=${encodeURIComponent(apmid)}`;
  if (isCatalogPart) filter += `&is_catalog_part=true`;
  if (parentOnly) filter += `&parentOnly=true`;
  if (orderable) filter += `&orderable=true`;
  if (deleted) filter += `&deleted=true`;
  if (kind?.length) filter += `&kind=${encodeURIComponent(kind)}`;

  return getServiceCatalog(`/public/infra-service/?limit=${limit}&skip=${skip}${filter}`);
};
